import React, { useContext, useState } from "react";
import { ClientContext } from "../../../../contexts/ClientContext";
import ModalContext from "../../../../contexts/ModalContext";
import cross from '../../../../assets/orders/cross.svg'
import { elements } from "./utils";
import { 
    Container,
    HeaderDiv,
    HeaderText,
    Text,
    TextLabel,
    GridContainer, 
    CloseDiv,
    CloseImg,
    OptionsDiv,
    ButtonOfSectionText,
    ButtonOfSection,
    IconImg,
    LineDiv
} from "./style";

export interface ClientInterface {
    cep: string,
    number: string,
    street: string,
    state: string,
    city: string,
    neighborhood: string,
    complement: string,
    days: string,
    hours: string,
}


const ClientDetail = ()=>{
    const {client, setClient} = useContext(ClientContext);
    const {setModalActive, setModalSection} = useContext(ModalContext)
    const [clientData, setClientData] = useState({
            cep: client?.cep.slice(0,5) + '-' + client?.cep.slice(5) || '',
            number: client?.number || '',
            street: client?.street || '',
            state: client?.state || '',
            city: client?.city || '',
            neighborhood: client?.neighborhood || '',
            complement: client?.complement || '',
            days: client?.days || '',
            hours: client?.hours || '',
    })
    
    const close = ()=>{
        setModalActive(false)
    }   
    
    return(
        <>
        <Container>
            <GridContainer>
            <HeaderDiv style={{gridArea: `titleNew`}}>
                <HeaderText>{'Cliente: ' + client?.name}</HeaderText>
                <CloseDiv onClick={()=>close()}>
                    <CloseImg src={cross}></CloseImg>
                </CloseDiv>
                </HeaderDiv>

                {
                   elements.map((element, index)=>{
                    return(
                        <>
                        <TextLabel style={{gridArea : element.field + 'Label'}}> {element.label}</TextLabel>
                        <Text style={{gridArea : element.field}}>{clientData[element.field]}</Text>
                        </>
                    )
                   }) 
                }
                <LineDiv></LineDiv>
            </GridContainer>
        </Container>
        </>
    )
}

export default ClientDetail;